import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import {
  Row, Col, Spin,
} from 'antd';
import AppApplyModal from '../util/AppApplyModal';
import CsRadioGroup from '../public/cs-radio-group';
import Apps from './Apps';
import validate from '../util/appApply/validate';
import ApplyApp from '../util/appApply/index';
import util from '../../util/index';
const { defaultCustomSearchValue } = util;
const store = ['modeListStore', 'homeStore', 'listStore']
const {
  checkLicense,
} = validate;
@inject(...store)
@observer
class App extends React.Component {

  constructor(props) {
    super(props);
    this.scrollTop = 0;
    this.state = {
      width: 1340,
      col: 6,
    }
  }
  componentDidMount() {
    const {
      homeStore: { type },
      listStore: { params: { searchValue } },
      modeListStore: { getMould, init, getModeList, getGenre, setMobxState },
    } = this.props;
    init();
    this.handlerResize();
    getGenre();
    const modeType = getMould(toJS(type).id);
    setMobxState({ modeType });
    getModeList({ searchValue, current: 1, module: modeType });
    if (window.location.hash.indexOf('appId') >= 0) {
      const keys = window.location.hash.slice(3).split('&');
      keys.forEach(k => {
        if (k.indexOf('appId') >= 0) {
          this.apply(k.split('=')[1]);
        }
      })
    }
    window.addEventListener('scroll', this.scrollHandler);
    window.addEventListener('resize', this.handlerResize);
  }

  componentWillReceiveProps() {
    const {
      homeStore: { type },
      listStore: { params: { searchValue } },
      modeListStore: { setMobxState, modeType, getModeList, getMould },
    } = this.props;
    const res = getMould(toJS(type).id);
    if (res && res !== modeType) {
      setMobxState({ current: 1, modeType: res });
      getModeList({ searchValue, current: 1, module: res });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollHandler);
    window.removeEventListener('resize', this.handlerResize);
  }

  handlerResize = () => {
    const { col } = this.state;
    const { modeListStore: { setMobxState, pageSize } } = this.props;
    const cWidth = document.clientWidth || document.documentElement.clientWidth;
    const sWidth = document.scrollWidth || document.documentElement.scrollWidth;
    const docWidth = Math.max(cWidth, sWidth) - 190;

    const cHeight = document.clientHeight || document.documentElement.clientHeight;
    const sHeight = document.scrollHeight || document.documentElement.scrollHeight;
    const docHeight= Math.max(cHeight, sHeight) - 430;
    const row = Math.ceil(docHeight / 150);
    let span = Math.ceil(275 / docWidth * 24);
    if (span === 5 || span === 7) span += 1;
    if (span > 8 && span < 12) span = 12;
    if (span > 12) span = 24;
    if (col !== span) this.setState({ width: docWidth, col: span });
    if (col * row !== pageSize) setMobxState({ pageSize: col * row});
  }

  scrollHandler = () => {
    if (this.modeList) {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > this.scrollTop) {
        const { listStore: { params: { searchValue } }, homeStore: { type }, modeListStore: { getMould, getModeList, current, modeCount, pageSize, loading, setMobxState } } = this.props;
        if (current * pageSize < modeCount && !loading) {
          const modeType = getMould(toJS(type).id);
          getModeList({ searchValue, current: current + 1, pageSize, module: modeType });
          setMobxState({ current: current + 1, modeType });
        }
      }
      this.scrollTop = scrollTop;
    }
  }

  onChangeModeType = (modeType) => {
    const { listStore: { params: { searchValue } }, modeListStore: { setMobxState, getModeList } } = this.props;
    setMobxState({ current: 1, modeType });
    getModeList({ searchValue, current: 1, module: modeType });
  }

  onChangeAppType = (appType) => {
    const { listStore: { params: { searchValue } }, modeListStore: { setMobxState, getModeList } } = this.props;
    setMobxState({ current: 1, appType });
    getModeList({ searchValue, current: 1, apptype: appType });
  }

  getModeItem = () => {
    return [
      {
        key: 'type', name: '类别',
        data: [{ key: 'ea393802-8f4a-4ef0-a4e2-6fe4915cb8c7', name: '业务建模' }, { key: '7429b7e4-1840-400c-9d32-c99f8ad2a939', name: '移动建模' }],
        defaultValue: 'ea393802-8f4a-4ef0-a4e2-6fe4915cb8c7',
      }
    ];
  }
  getIndItem = () => {
    const { modeListStore: { genre } } = this.props;
    return [
      {
        key: 'ind', name: '行业',
        data: [
          { key: 'all', name: '全部' },
          ...toJS(genre)
        ],
        defaultValue: 'all',
      }
    ];
  }
  getTerminalItem = () => {
    return [
      {
        key: 'terminal', name: '终端',
        data: [
          { key: 'all', name: '全部' }, { key: 'PC', name: 'PC' }, { key: 'MOBILE', name: 'MOBILE' },
        ],
        defaultValue: 'all',
      }
    ];
  }

  onSort = (type) => {
    const { listStore: { params: { searchValue } }, modeListStore: { setMobxState, getModeList } } = this.props;
    setMobxState({ current: 1, type });
    getModeList({ searchValue, current: 1, type });
  }

  apply = (id) => {
    const { modeListStore: { setMobxState, getAppDetail } } = this.props;
    getAppDetail({ id }).then(() => {
      setMobxState({ visibleOfApply: true });
    });
  }

  onFormChange = (values, allValues) => {
    const { modeListStore: { applyLicense, setMobxState, appDetail } } = this.props;
    const data = toJS(appDetail);
    setMobxState({ isApply: false });
    if (Object.keys(values).indexOf('license') >= 0) {
      checkLicense(values.license) && applyLicense({
        sw_id: data.sw_id,
        ec_id: allValues.c_id,
        c_id: allValues.c_id,
        ecname: allValues.c_name,
        license: values.license,
      });
    }
  }
  render() {
    const { col } = this.state;
    let { homeStore: { type }, modeListStore, modeListStore: { appDetail, visibleOfApply, loading, modeList, setMobxState, modeType, visible, appType } } = this.props;
    modeList = toJS(modeList);
    appDetail = toJS(appDetail);
    const isSearch = window.location.hash.indexOf('app/search') >= 0;
    return (
      <div ref={c => this.modeList = c} className='home-page-theme-list home-page-mode-list' style={isSearch ? { paddingTop: 0 } : {}}>
        {
          toJS(type).id === 'mode' && (<CsRadioGroup datas={this.getModeItem()} values={[modeType]} onChange={(e) => this.onChangeModeType(e.target.value)} />)
        }
        {
          toJS(type).id === 'dev' || toJS(type).id === 'nStandard' && (<CsRadioGroup datas={this.getTerminalItem()} values={[appType]} onChange={(e) => this.onChangeAppType(e.target.value)} />)
        }
        <div className="mode-tool">
          <span className={`mode-tool-btn${modeListStore.type === 1 ? '-active' : ''}`} onClick={() => this.onSort(1)}>热度</span>
          <span className={`mode-tool-btn${modeListStore.type === 2 ? '-active' : ''}`} onClick={() => this.onSort(2)}>更新日期</span>
          <span className={`mode-tool-btn${modeListStore.type === 3 ? '-active' : ''}`} onClick={() => this.onSort(3)}>发布日期</span>
        </div>
        <Spin spinning={loading}>
          <Row className="mode-content">
            {
              modeList && modeList.length > 0 ? modeList.map(t => (
                <Col
                  key={t.s_id}
                  span={col}
                  onMouseOver={(e) => {
                    setMobxState({ appHotSelected: t.s_id });
                    e.stopPropagation && e.stopPropagation();
                    e.preventDefault && e.preventDefault();
                    e.nativeEvent && e.nativeEvent.preventDefault();
                  }}
                  onMouseOut={(e) => {
                    setMobxState({ appHotSelected: '' });
                    e.stopPropagation && e.stopPropagation();
                    e.preventDefault && e.preventDefault();
                    e.nativeEvent && e.nativeEvent.preventDefault();
                  }}
                >
                  <Apps data={t} apply={this.apply}/>
                </Col>
              )) : !loading ? (
                  <div style={{ paddingTop: 120 }}>
                    <div className="icon-Cloud-No-data" />
                    <p style={{ textAlign: 'center' }}>暂无数据</p>
                  </div>
                ) : null
            }
          </Row>
        </Spin>
        <AppApplyModal handleCloseModal={() => setMobxState({ visible: false })} applyModal={{ visible }} applyApps={{}} />
        <ApplyApp visible={visibleOfApply} onChange={(v) => setMobxState({ visibleOfApply: v })} data={appDetail} onFormChange={this.onFormChange} />
      </div>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/mode/AppList.js